"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _types = require("../utils/types");

var _SortIcon = _interopRequireDefault(require("./SortIcon"));

var _SelectInput = _interopRequireDefault(require("../../SelectInput"));

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HeaderMini = function HeaderMini(_ref) {
  var columns = _ref.columns,
      sorting = _ref.sorting,
      changeSorting = _ref.changeSorting,
      sortByLabel = _ref.headerControls.sortByLabel;
  var options = columns.filter(function (_ref2) {
    var sortable = _ref2.sortable;
    return sortable;
  }).map(function (_ref3) {
    var key = _ref3.key,
        title = _ref3.title,
        sorter = _ref3.sorter;
    return {
      value: key,
      label: title || key,
      sorter: sorter
    };
  });

  var _useState = (0, _react.useState)(sorting.key),
      _useState2 = _slicedToArray(_useState, 2),
      selectedColumn = _useState2[0],
      setColumn = _useState2[1];

  var hasActiveSort = !!sorting.key;
  var sortDirection = hasActiveSort ? _constants.SORT_ORDER_MINI.indexOf(sorting.direction) : 0;

  var onSort = function onSort(columnKey) {
    var column = options.find(function (option) {
      return option.value === columnKey;
    });
    var directionIndex = sortDirection === _constants.SORT_ORDER_MINI.length - 1 ? 0 : sortDirection + 1;
    changeSorting({
      key: columnKey,
      sorter: column.sorter,
      direction: _constants.SORT_ORDER_MINI[directionIndex]
    });
  };

  var onColumnSelect = function onColumnSelect(selectedColumn) {
    setColumn(selectedColumn);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Table-header-mini",
    role: "row"
  }, /*#__PURE__*/_react.default.createElement("span", null, sortByLabel), /*#__PURE__*/_react.default.createElement(_SelectInput.default, {
    value: selectedColumn,
    selectedOption: selectedColumn,
    options: options,
    onChange: onColumnSelect
  }), selectedColumn && options.length && /*#__PURE__*/_react.default.createElement(_SortIcon.default, {
    isSorted: hasActiveSort,
    direction: _constants.SORT_ORDER_MINI[sortDirection],
    handleSort: function handleSort() {
      return onSort(selectedColumn);
    }
  }));
};

HeaderMini.propTypes = {
  sorting: _types.sortState,

  /** Table header cells list */
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    title: _propTypes.default.string,
    sortable: _propTypes.default.bool
  })),
  headerControls: _propTypes.default.shape({
    sortByLabel: _propTypes.default.string
  }).isRequired,
  changeSorting: _propTypes.default.func
};
HeaderMini.defaultProps = {
  sorting: {},
  columns: [],
  changeSorting: function changeSorting() {}
};
var _default = HeaderMini;
exports.default = _default;